import React from 'react';
import CuadroDatos from '../../UI/CuadroDatos.js';
import ListaTiposTorneoOrganizador from './ListaTiposTorneoOrganizador.js';
import styles from './CuadroTorneosSelec.module.css';

const CuadroTorneosSelec = (props) => {
  const organizadores = props.organizadores;

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos titulo={'Torneos'} mostrar={true} isCargando={false} error={false}>
        <table className={`${styles.tablaTorneos}`}>
          <tbody>
            {organizadores &&
              organizadores.map((organizador, index) => (
                <React.Fragment>
                  <tr key={'O' + index} className={`${styles.organizador}`}>
                    <td className={`${styles.organizador}`}>{organizador.nombre}</td>
                  </tr>
                  <ListaTiposTorneoOrganizador
                    key={index}
                    organizador={organizador}
                    styles={styles}
                  />
                </React.Fragment>
              ))}
          </tbody>
        </table>
      </CuadroDatos>
    </div>
  );
};

export default CuadroTorneosSelec;
